<template>
    <div class="question scrollToItem hasValidation"
         :class="{'has-error': errors[leadKey]}"
         :id="leadKey"
         v-if="questions.length > 0">

        <true-panel class="questionInner">

            <section class="questionHeader">
                <div class="questionText"> {{ question.text }} </div>
            </section>

            <section class="questionLearnMore">
                <div class="questionLearnMoreToggle"
                     v-if="this.$slots['learn-more']">
                    <div @click="toggleLearnMore">Why are we asking about this?</div>
                </div>
                <div v-if="this.$slots['learn-more'] && learnMoreVisible">
                    <hr>
                    <slot name="learn-more"></slot>
                    <div class="questionLearnMoreToggle"
                         @click="toggleLearnMore">Thanks. You can hide this information.</div>
                </div>
            </section>

            <section v-if="!moreInput || lead[leadKey] !== lastChoice.text && moreInput" 
                    class="questionChoices"
                     :class="{
                         'multiple': isMultiple,
                         'single': isSingle
                     }">

                <div class="questionChoice"
                     :class="{
                         'selected': isSelected(choice.text),
                         'hidden': isEmptyValue(choice.text)
                     }"
                     @click="handleOptionClick(choice.text)"
                     v-for="choice in question.choices">
                    {{ choice.text }}
                </div>

            </section>

            <div class="moreInput"
                 v-if="lead[leadKey] === lastChoice.text && moreInput">
                <div class="form-group">
                    <!-- <label for="">How many?</label> -->
                    <input type="number"
                           class="form-control"
                           v-model="answerInput" />
                </div>
            </div>

        </true-panel>
        <!-- .question-inner -->

        <div class="errorMessages"
             v-show="errors[leadKey]">
            <div v-for="message in errors[leadKey]"> {{ message }} </div>
        </div>

    </div>
    <!-- .question -->
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  props: ["id", "lead-key", "more-input", "type", "more-value"],
  data() {
    return {
      answer: null,
      answerInput: null,
      learnMoreVisible: false
    };
  },
  computed: {
    ...mapState(["errors", "lead", "questions"]),
    ...mapGetters(["getQuestionById"]),

    question() {
      let id = parseInt(this.id);
      let question = this.getQuestionById(id);
      let choicesCount = question.choices.length;
      if (this.type == "multiple") {
        if (choicesCount > 3 && choicesCount < 6) {
          let numberShort = 6 - choicesCount;
          for (var i = 0; i < numberShort; i++) {
            question.choices.push("");
          }
        }
      }
      return question;
    },

    isMultiple() {
      return this.type == "multiple";
    },

    isSingle() {
      return this.type == "single" || !this.type;
    },

    lastChoice() {
      let choices = this.question.choices;
      return choices[choices.length - 1];
    }
  },
  methods: {
    ...mapActions(["answerQuestion", "save"]),

    handleOptionClick(value) {
      let type = this.type || "single";
      let payload = {
        leadKey: this.leadKey,
        value,
        type
      };
      this.answerQuestion(payload).then(() => this.save());
    },

    isSelected(choiceText) {
      let leadAnswer = this.lead[this.leadKey];
      if (Array.isArray(leadAnswer)) {
        return leadAnswer.includes(choiceText);
      } else {
        return leadAnswer === choiceText ? true : false;
      }
    },

    isEmptyValue(value) {
      return value == "" || value == null;
    },

    toggleLearnMore() {
      this.learnMoreVisible = !this.learnMoreVisible;
    }
  },

  mounted() {
    if (this.moreInput) {
      this.$watch("answerInput", (v, o) => {
        let type = this.type || "single";
        let payload = {
          leadKey: `${this.leadKey}Input`,
          value: v,
          type: "input"
        };
        this.answerQuestion(payload).then(() => this.save());
      });
    }
  },

  updated() {
    if (this.moreValue) {
      let value = this.lead[`${this.leadKey}Input`];
      let valid = value === "" || parseInt(value) > -1;
      this.answerInput = valid ? value : this.moreValue;
    }
  }
};
</script>

<style lang="css"></style>
